/* discount-product.js  – 20 % CAD discount that never loses the race */
document.addEventListener('DOMContentLoaded', () => {

  /* settings you can tweak ---------------------------------------- */
  const DISCOUNT   = 0.20;                   // 20 %
  const CURRENCY   = 'CAD';
  const EXTRA_TEXT = ' | 💥 VENDREDI FOU 💥';
  const SELECTORS  = [
    '.complementary-product__price.money',
    '.price price--sale',
    '.rc-option__price.rc_widget__price.rc_widget__price--onetime'
  ];
  /* ---------------------------------------------------------------- */

  const fmt = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: 2
  });

function applyDiscount(el) {
  /* If our promo copy is already in there, do nothing */
  if (el.textContent.includes(EXTRA_TEXT)) return;

  const m = el.textContent.match(/[\d.,]+/);
  if (!m) return;

  const base = parseFloat(m[0].replace(/,/g, ''));
  if (isNaN(base)) return;

  const original   = fmt.format(base);
  const discounted = fmt.format(base * (1 - DISCOUNT));

  el.innerHTML =
    `<span class="do-not-show" style="text-decoration:line-through;opacity:.7;margin-right:.25em">${original}</span>` +
    `<span style="font-weight:700;color:#e60000">${discounted}${EXTRA_TEXT}</span>`;
}

  function scan(root = document) {
    SELECTORS.forEach(sel =>
      root.querySelectorAll(sel).forEach(applyDiscount)
    );
  }

  /* first pass */
  scan();

  /* run every 300 ms – cheap, never misses a repaint */
  setInterval(scan, 300);
});
